export default __webpack_public_path__ + "static/media/connectedness-tree.74c84c29.svg";